import { render, staticRenderFns } from "./valuetypedetail.vue?vue&type=template&id=befd2d6e&"
import script from "./valuetypedetail.vue?vue&type=script&lang=js&"
export * from "./valuetypedetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports